module.exports = __webpack_public_path__ + "img/svg/filter-active.c30352ba6223dce786d51dae6e1e3255.svg";